import subscriptionService from '../services/subscription.service';

const subscriptions = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE
        create(_, model) {
            return subscriptionService.create(model);
        },

        //READ
        get(_, params) {
            return subscriptionService.get(params.id, params.urlParameters, params.requestId);
        },
        getlist() {
            return subscriptionService.getlist();
        },

        //UPDATE
        update(_, model) {
            return subscriptionService.update(model);
        },

        //DELETE
        delete(_, id) {
            return subscriptionService.delete(id);
        },
    },
    getters: {},
    mutations: {},
};

export default subscriptions;
